// Include the root itself: a Turbo stream can insert a tooltip as its top node.
export function attachTooltips(root = document) {
  const attach = element => {
    const current = element.getAttribute('data-controller') || ''
    if (!current.split(/\s+/).includes('tooltip')) {
      element.setAttribute('data-controller', `${current} tooltip`.trim())
    }
  }
  if (root.matches?.('[data-tip]')) attach(root)
  root.querySelectorAll('[data-tip]').forEach(attach)
}
